export default __webpack_public_path__ + "static/media/deleted.332f3c14.png";